import React from "react";
import styled from "styled-components";
import RadioButton from "./RadioButton";
import SubmitButton from "../SubmitButton";
import { FormattedMessage } from "react-intl";

import TextF2 from "../TextF2";
import TextF5 from "../TextF5";
import TextF6 from "../TextF6";
import TextF8 from "../TextF8";

import Box from "../Box";
import { themeGet } from "styled-system";
import { MediumContainer } from "../Grid";

import _get from "lodash/get";
import _includes from "lodash/includes";

const ExcercisesCompleted = styled(TextF2)`
  color: #29264c;
  margin: 0;
  line-height: 1;
`;
const ExcercisesTotal = styled(TextF5)`
  color: #29264c;
  margin: 0;
  line-height: 1;
  font-family: ${themeGet("fonts.TTNormsProRegular")};
  margin-bottom: 0.2rem;
  padding-left: 0.2rem;
  @media screen and (min-width: 38em) {
    margin-bottom: 0.45rem;
  }
`;

const RowWrapper = styled(Box)`
  flex-direction: column;
  display: flex;
  @media screen and (min-width: 72em) {
    flex-direction: row;
    align-items: top;
    justify-content: space-between;
  }
`;

const Question = styled(TextF6)`
  font-weight: normal;
  text-align: left;
  margin-top: 0;
  margin-bottom: 1rem;
  @media screen and (min-width: 72em) {
    margin-bottom: 0;
  }
`;

const ChoiceWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  @media screen and (min-width: 72em) {
    flex-wrap: no-wrap;
    justify-content: flex-end;
    align-items: start;
    flex-shrink: 0;
  }
`;

const Answer = styled(TextF8)`
  margin-top: 0;
  font-weight: normal;
  margin: 0.5rem 0;
  padding: 4px 16px;
  border-left: 4px solid ${props =>
    props.correctAnswer ? "#19CA94" : "#E02C00"}
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;

export default class RadioMatrix extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: {}
    };
  }

  isCorrect(itemId, optionId) {
    const { rightAnswer } = this.props;

    return _includes(_get(rightAnswer, itemId, []), optionId);
  }

  allAnswered() {
    const { quiz, answer } = this.props;
    return quiz.data.items
      .map(item => (_get(answer, item.id) || []).length > 0)
      .every(v => !!v);
  }

  allCorrect(itemId) {
    const { quiz, answer, rightAnswer } = this.props;
    const meta = _get(quiz, "data.meta") || [];
    const rightItemAnswer = _get(rightAnswer, itemId, []);

    if (_get(meta, "multi")) {
      return answer.map(k => k in rightItemAnswer).every(v => !!v);
    }
    return _includes(rightItemAnswer, answer[itemId]);
  }

  isChecked(itemId, optionId) {
    const { quiz, answer } = this.props;
    const meta = _get(quiz, "data.meta") || [];

    if (_get(meta, "multi")) {
      return _includes(answer[itemId], optionId);
    }

    return optionId === answer[itemId];
  }

  isDisabled() {
    return (
      !this.props.loggedIn ||
      !this.allAnswered() ||
      this.props.submitted ||
      this.props.submitting
    );
  }

  render() {
    const {
      quiz,
      submitted,
      submitting,
      validating,
      validation,
      messages,
      onSubmit,
    } = this.props;

    const onSelected = this.props.onRadioMatrixChange;

    if (!quiz || (!!quiz && !quiz.data)) {
      return null;
    }

    return (
      <div>
        {(quiz.data.items || []).map(item => {
          const itemId = item.id;
          return (
            <div key={"row-" + itemId} className="question-panel">
              <MediumContainer>
                <RowWrapper>
                  <Question>
                    <div dangerouslySetInnerHTML={{ __html: item.title }} />
                  </Question>
                  <ChoiceWrapper>
                    {quiz.data.choices.map(choice => {
                      const choiceId = choice.id;
                      const buttonState =
                        submitted && !validating
                          ? [
                              this.isChecked(itemId, choiceId)
                                ? [
                                    this.isCorrect(itemId, choiceId)
                                      ? "selected-correct"
                                      : "selected-wrong"
                                  ]
                                : [
                                    this.isCorrect(itemId, choiceId)
                                      ? "not-selected-correct"
                                      : "not-selected-wrong"
                                  ]
                            ]
                          : [
                              this.isChecked(itemId, choiceId)
                                ? "selected"
                                : "default"
                            ];

                      return (
                        <Box
                          key={`input-${quiz.id}-${choiceId}`}
                          display="flex"
                          justifyContent="center"
                        >
                          <RadioButton
                            name={`${quiz.id}-${itemId}`}
                            title={choice.title}
                            checked={this.isChecked(itemId, choiceId)}
                            buttonState={buttonState}
                            disabled={submitted}
                            onClick={() => {
                              if (!submitted && !submitting)
                                onSelected(itemId, choiceId);
                            }}
                          />
                        </Box>
                      );
                    })}
                  </ChoiceWrapper>
                </RowWrapper>
              </MediumContainer>
              {submitted ? (
                <MediumContainer>
                  {!!messages[itemId] ? (
                    <Answer correctAnswer={!messages[itemId].error}>
                      <span>{messages[itemId].message}</span>
                    </Answer>
                  ) : null}
                </MediumContainer>
              ) : (
                ""
              )}
            </div>
          );
        })}
        <div className="question-panel">
          <MediumContainer>
            {submitted && !validating && !!validation ? (
              <div>
                <TextF8 m={0} color="rgba(41,38,76,0.5)">
                  <FormattedMessage id="exercise.score" />
                </TextF8>
                <Box display="flex" alignItems="flex-end" justifyContent="left">
                  <ExcercisesCompleted>{validation.points}</ExcercisesCompleted>
                  <ExcercisesTotal>/ {validation.maxPoints}</ExcercisesTotal>
                </Box>
              </div>
            ) : (
              <Box display="flex" justifyContent="flex-end" align-items="start">
                <SubmitButton
                  onSubmit={() => onSubmit()}
                  submitted={submitted}
                  submitting={submitting}
                  disabled={this.isDisabled()}
                />
              </Box>
            )}
          </MediumContainer>
        </div>
      </div>
    );
  }
}
